import React, { useRef, useState } from "react";
import "./index.less";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css"; // 引入 Bootstrap 的 CSS
import logo from "@/assets/Logo.png";
import CustomBtn from "@/components/CustomBtn";

const BottomPage = () => {
  const ContacData = [
      {
        title: "Home",
        path: "/",
      },
      {
        title: "About Us",
        path: "/about",
      },
      {
        title: "Products",
        path: "/product",
      },
      {
        title: "Services",
        path: "/services",
      },
      {
        title: "Industries & Advantages",
        path: "/industries",
      },
      {
        title: "Contact Us",
        path: "/contact",
      },
    ];
    
  const navigate = useNavigate()
  const linkChange=(path)=>{
    const newPath = path.slice(0,path.indexOf('?'))
    console.log(newPath)
    navigate(newPath+'?id=1')
    setTimeout(() => {
      navigate(path)
    }, 0);
  }
  return (
    <div className="contact_warp">
      <div className="contact_box row">
        <div className="left col-5">
            <div className="logo"><img src={logo} alt="" /></div>
            <p className="slogan">Unlock Unlimited Potential with Cutting-Edge Compute Power.</p>
        </div>
        <div className="right col-6">
        <div className="contact_item">
          {ContacData.map((val) => {
            return (             
                <div className="title" onClick={()=>linkChange(val.path)}>{val.title}</div>              
            );
          })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomPage;
